import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createStatCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers/statCardBlockHelper";
import {
  getBlockPrimaryStyleOptions,
  primaryBlockDefaultStyles,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/stylesHelpers";
import {
  createH3Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getPaddingOptions } from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBorderColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getMaxWidthOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import {
  getColorOptions,
  getFontSizeOptions,
  getFontWeightOptions,
  getTextAlignOptions,
} from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";

const stats = [
  {
    number: "300+",
    text: "creators & educators supported",
  },
  {
    number: "$1.2M+",
    text: "in total member launch revenue",
  },
  {
    number: "50+",
    text: "industries—from coaching to creative to technical",
  },
] as const;

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "EvergreenHomepageBlock6",
  props: {
    content: {
      prop: "children",
      type: "children",
      value: stats.map(({ number, text }) => {
        const value = [
          createH3Block({
            text: number,
            styles: {
              color: getColorOptions("var(--theme-website-color-6)"),
              fontWeight: getFontWeightOptions("400"),
              fontSize: getFontSizeOptions("4.5rem"),
            },
          }),
          createPBlock({
            text,
            styles: {
              fontWeight: getFontWeightOptions("600"),
              fontSize: getFontSizeOptions("1.25rem"),
              maxWidth: getMaxWidthOptions({
                defaultValue: "254px",
              }),
            },
          }),
        ];
        return createStatCardBlock({
          value,
          styles: {
            padding: getPaddingOptions({
              defaultValue: {
                paddingTop: "0",
                paddingRight: "0",
                paddingLeft: "0",
                paddingBottom: "0",
              },
            }),
            borderColor: getBorderColorOptions({
              defaultValue: primaryBlockDefaultStyles.backgroundColor,
            }),
            textAlign: getTextAlignOptions("left"),
          },
        });
      }),
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getBlockPrimaryStyleOptions(),
      },
    },
  },
};
